<template>
  <div id="app" style="">
    <span id="ty-computeWidth-th" style="position: absolute;left: 0;top: 0;visibility: hidden;"></span>
    <template v-show="!hideHeaderFooter">
      <!-- 顶部 -->
      <transition name="el-fade-in-linear">
        <Header></Header>
      </transition>
      <transition name="el-fade-in-linear">
        <router-view />
      </transition>
      <template v-if="adsList.side">
        <div
          v-show="adsLeftShow"
          style="position: fixed;top: 30%;width: 100px;height: 300px;z-index:999"
        >
          <a :href="adsList.side[0].link" target="_blank">
            <img :src="adsList.side[0].image" style="width: 100%;height: 100%;" />
          </a>
          <div class="ads-close-text" @click="adsLeftShow = false">关闭</div>
        </div>
        <div
          v-show="adsRightShow"
          style="position: fixed;top: 30%;right: 0;width: 100px;height: 300px;z-index:999"
        >
          <a :href="adsList.side[1].link" target="_blank">
            <img :src="adsList.side[1].image" style="width: 100%;height: 100%;" />
          </a>
          <div class="ads-close-text" @click="adsRightShow = false">关闭</div>
        </div>
      </template>
      <!-- 底部 -->
      <transition name="list" tag="p">
        <div v-if="adsList.bottom" class="list-item">
          <div v-show="adsBotoomShow" style="height: 80px;position: relative;">
            <i
              class="el-icon-error"
              style="position: absolute;right: 10px;top: 5px;color: #014099;"
              @click="adsBotoomShow = false"
            ></i>
            <a :href="adsList.bottom.link" target="_blank">
              <img :src="adsList.bottom.image" style="width: 100%;height: 100%;" />
            </a>
          </div>
        </div>
      </transition>
      <transition name="el-fade-in-linear">
        <Footer></Footer>
      </transition>
    </template>
  </div>
</template>

<script>
import Header from "@/common/header";
import Footer from "@/common/footer";
export default {
  data() {
    return {
      adsList: {},
      adsLeftShow: true,
      adsRightShow: true,
      adsBotoomShow: true
    };
  },
  components: {
    Header,
    Footer
  },
  mounted() {
    this.getAdsList();
  },
  methods: {
    getAdsList() {
      this.api
        .getAdList()
        .then(res => {
          this.adsList = res;
          // console.log(res)
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  computed: {
    hideHeaderFooter: function() {
      return location.href.indexOf("payGateWay") != -1;
    }
  }
};
</script>

<style>
@import "styles/style.css";
.el-button--primary {
  background: #014099 !important;
  border-color: #014099 !important;

}
.el-button--primary:focus,
.el-button--primary:hover {
  cursor: default;
}
.el-input.is-active .el-input__inner,
.el-input__inner:focus {
  border-color: #014099;
}
.el-carousel__indicators--vertical {
  display: none;
}
/*table*/
.el-table__body,
.el-table__footer,
.el-table__header {
  border-collapse: collapse;
}
.el-table td,
.el-table th {
  padding: 8px 0;
  border-color: #555;
  color:#444;
}
.el-table--border th,
.el-table__fixed-right-patch {
  padding: 7px 0;

}
.el-table th > .cell {
  font-weight: 400;
  color: #333;
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #f2f8ff;
}
.el-table--border {
  border-radius: 3px;
}

/*分页*/
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #014099;
}

/*单选多选按钮字体大小*/
.el-checkbox__label {
  font-size: 12px;
  line-height: 14px;
  color: #333;
}

/*弹窗标题*/
.el-dialog__title {
  color: #014099;
  font-size: 24px;
}
.el-dialog__header {
  padding-top: 40px;
}

/**/
.el-select {
  width: 100%;
}

.ads-close-text {
  text-align: center;
  background: #ccc;
  line-height: 25px;
}
.list-item {
  width: 100%;
  margin-right: 10px;
  position: fixed;
  bottom: 0;
  background: #fff;
  z-index: 10;
}
.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter, .list-leave-to
    /* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}

.el-input__inner,
.el-range-input {
  border-color: #999 !important;
}

.el-input__inner:hover,
.el-range-input:hover {
  border-color: #999 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue